module.exports = __webpack_public_path__ + "static/media/moeda.60990589.svg";